import { Component, OnInit, Input, forwardRef, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { VirtualStoreService } from 'src/app/services/virtual-store.service';

@Component({
  selector: 'app-number-picker',
  templateUrl: './number-picker.component.html',
  styleUrls: ['./number-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumberPickerComponent),
      multi: true
    }
  ]
})
export class NumberPickerComponent implements OnInit, ControlValueAccessor {
  @Output() countChanged = new EventEmitter<any>();

  maxCount = 100;
  minCount = 1;
  onChange = (_: any) => { };
  onTouched: () => {};
  writeValue(count: number): void {
    if (this.isBetweenLimits(count)) {
      this.currentCount = count;
      this.onChange(count);
    } else {
      this.currentCount = 1;
      this.onChange(count);
    }

  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public currentCount = 1;

  constructor(private virtualStoreService: VirtualStoreService) { }

  ngOnInit() {
  }

  increment() {
    let previousValue = this.currentCount;
    let newValue = this.currentCount + 1;
    if (this.isBetweenLimits(newValue)) {
      this.currentCount = newValue;
      this.onChange(this.currentCount);
      this.countChanged.emit({
        previousValue: previousValue,
        newValue: newValue
      });
    }
  }

  decrement() {
    let previousValue = this.currentCount;
    let newValue = this.currentCount - 1;
    if (this.isBetweenLimits(newValue)) {
      this.currentCount = newValue;
      this.onChange(this.currentCount);
      this.countChanged.emit({
        previousValue: previousValue,
        newValue: newValue
      });
    }
  }

  isBetweenLimits(value: number) {
    if (value) {
      return value >= this.minCount && value <= this.maxCount;
    } else { return false; }
  }
}
